<dx-scroll-view
    #scrollView
    class="w-100 h-100"
    [scrollByContent]="true"
    [scrollByThumb]="true"
    showScrollbar="always"
>
    <div class="w-100 h-100 pe-1">
        <dx-form
            [items]="items"
            [(formData)]="formData"
            [readOnly]="false"
            [validationGroup]="validationGroupName()"
            colCount="auto"
            [minColWidth]="250"
            [colCountByScreen]="{ xs: 1, sm: 1, md: 1, lg: 1 }"
            [showValidationSummary]="true"
        >
        </dx-form>
    </div>
</dx-scroll-view>

@if (loadIndicatorVisible) {
<app-load-indicator />
}
